import { createFileRoute } from "@tanstack/react-router";

import { RunPage } from "@/features/run/run-page";
import { flag, positiveInt } from "@/lib/search";
import { uploadSearch, type UploadSearch } from "@/lib/upload-route";

export interface RunSearch extends UploadSearch {
  /** The guide's info dialog is open. */
  info?: true;
  /** 1-based guide step; takes precedence over saved progress. */
  step?: number;
  /** The old tab param: read once (`details` → `info`) and dropped from the URL. */
  tab?: undefined;
}

export const Route = createFileRoute("/runs/$id")({
  validateSearch: (raw: Record<string, unknown>): RunSearch => ({
    info: flag(raw.info) ?? (raw.tab === "details" ? true : undefined),
    step: positiveInt(raw.step),
    tab: undefined,
    ...uploadSearch(raw),
  }),
  component: RunRoute,
});

function RunRoute() {
  const { id } = Route.useParams();
  const { info, step } = Route.useSearch();
  return <RunPage runId={id} info={info === true} step={step} />;
}
